import React from "react";
import { CheckCircle } from "lucide-react";
import Marketingcycle from "./Marketingcycle";
import Footer from "../../Home/Footer";
import WhatsAppServices from "../../Home/WhatsAppServices";
import Faqs from "../../Home/Faqs";
// Array for dynamic data
const travelLeadData = {
  heading: "Skyrocket Client Conversions with WhatsApp",
  points: [
    "Bring in more leads and sales for your clients effortlessly.",
    "Offer 24/7 support to keep customers happy and engaged.",
    "Send personal nudges to spark buying interest.",
  ],
  buttons: [
    { text: "Try ChatMitra for Growth", className: "bg-[#075E54] text-white hover:bg-[#064d40]" ,buttonLink:"https://app.chatmitra.com/signin" },
    { text: "Book a Live Demo", className: "border border-[#075E54] text-[#075E54] hover:text-white" },
  ],
  image: "https://chatmitra.s3.ap-south-1.amazonaws.com/chat-mitra-blog/marketing_agency/marketing_agency_1.png",
};



const clientConversionServices = [
  {
    id: 1,
    icon: <span className="text-2xl">📈</span>, // Chart icon
    title: "Turn Leads into Sales with WhatsApp",
    description: "Use personalized WhatsApp chats to nurture leads and close deals faster. It’s like having a sales rep who never sleeps!"
  },
  {
    id: 2,
    icon: <span className="text-2xl">💬</span>, // Chat bubble icon
    title: "Engage Prospects with WhatsApp Offers",
    description: "Send tailored discounts, free trials, and incentives via WhatsApp. Your prospects will feel valued and more likely to convert."
  },
  {
    id: 3,
    icon: <span className="text-2xl">📧</span>, // Email icon
    title: "Follow Up Effectively on WhatsApp",
    description: "Reconnect with warm leads and abandoned carts through WhatsApp. It’s less pushy than email and more personal—perfect for conversions."
  },
  {
    id: 4,
    icon: <span className="text-2xl">🤝</span>, // Handshake icon
    title: "Build Trust with WhatsApp Demos",
    description: "Offer live product demos or consultations via WhatsApp to show value. Clients will trust you more and convert quicker."
  },
  {
    id: 5,
    icon: <span className="text-2xl">💰</span>, // Money icon
    title: "Close Deals Faster on WhatsApp",
    description: "Negotiate terms, send contracts, and finalize payments all through WhatsApp. It’s a streamlined path to more sales."
  },
  {
    id: 6,
    icon: <span className="text-2xl">⭐</span>, // Star icon
    title: "Boost Loyalty with WhatsApp Rewards",
    description: "Reward new clients with discounts or perks via WhatsApp. It’s a simple way to turn one-time buyers into repeat customers."
  }
];


const clientConversionFAQs = [
  {
    question: "How can WhatsApp turn leads into clients?",
    answer: "WhatsApp can skyrocket conversions by sending personalized offers and follow-ups directly to leads. It’s like having a sales coach whispering the right words at the right time!"
  },
  {
    question: "Is WhatsApp effective for follow-up campaigns?",
    answer: "Yes! Use WhatsApp to reconnect with warm leads and abandoned carts with friendly reminders. It’s less pushy than emails and more personal, boosting your close rate."
  },
  {
    question: "Can WhatsApp handle sales demos for clients?",
    answer: "Absolutely! Offer live product demos or consultations via WhatsApp to show value. It’s like giving prospects a front-row seat to your solutions, making them eager to buy."
  },
  {
    question: "How does WhatsApp engage potential clients?",
    answer: "Send tailored discounts, free trials, and educational content via WhatsApp. It’s like building a relationship that turns curiosity into commitment, step by step."
  },
  {
    question: "Is WhatsApp secure for closing deals?",
    answer: "Yes, WhatsApp’s encryption keeps your deals and client data safe. It’s like locking your negotiations in a vault, so you can focus on sealing the deal confidently."
  },
  {
    question: "Can WhatsApp reduce my sales cycle time?",
    answer: "Definitely! Handle negotiations, send contracts, and finalize payments all via WhatsApp. It’s like streamlining your pipeline into a single, speedy chat!"
  },
  {
    question: "What kind of content should I share to convert clients?",
    answer: "Share case studies, testimonials, and special offers via WhatsApp. It’s a direct line to prove your value and nudge leads toward saying yes."
  },
  {
    question: "How do clients feel about using WhatsApp for sales?",
    answer: "They love it! Clients appreciate the convenience, speed, and personal touch of WhatsApp. It’s less formal than calls and more immediate, making buying a joy."
  },
  {
    question: "Can WhatsApp build long-term client loyalty?",
    answer: "Yes! Reward new clients with discounts or perks via WhatsApp, turning one-time buyers into repeat customers. It’s like planting seeds for a lasting partnership."
  },
  {
    question: "How do I start using WhatsApp for client conversions?",
    answer: "Set up WhatsApp Business, create chat templates for leads and follow-ups, and leverage tools like ChatMitra. It’s a quick way to skyrocket your sales!"
  },
];

const Marketing = () => {
  return (
    <>
      <section className="max-w-6xl mx-auto px-4 py-16 bg-white pt-28">
        <div className="flex flex-col lg:flex-row gap-12">
          <div className="w-full lg:w-1/2">
            <h1 className="text-4xl font-bold text-gray-800 mb-6">Skyrocket Client Conversions with WhatsApp</h1>
            <ul className="space-y-4 text-gray-700">
              {travelLeadData.points.map((point, index) => (
                <li key={index} className="flex items-start gap-3">
                  <CheckCircle className="text-[#075E54] w-5 h-5 flex-shrink-0" />
                  <span>{point}</span>
                </li>
              ))}
            </ul>
            <div className="mt-8 flex gap-4">
              {travelLeadData.buttons.map((button, index) => (
                <a
                key={index}
                href={button.buttonLink}
                className={`py-3 px-6 rounded-lg text-lg font-semibold ${button.className}`}
              >
                {button.text}
              </a>
              ))}
            </div>
          </div>
          <div className="w-full lg:w-1/2">
            <img src={travelLeadData.image} alt="Marketing Agency Leads" className="w-full h-auto rounded-lg  hover:scale-105 transition-transform" />
          </div>
        </div>

        <div className="max-w-6xl mx-auto px-4 py-8 text-center">
          <p className="text-lg text-gray-600">Help your clients shine with WhatsApp’s power. Start with ChatMitra today—no credit card needed!</p>
          <button className="mt-4 bg-[#075E54] text-white py-3 px-6 rounded-lg hover:bg-[#064d40] transition-colors">Get Start - No Credit Card Required</button>
        </div>
      </section>

      <Marketingcycle />

      <WhatsAppServices servicesData={clientConversionServices} isVisible={true}/>

      <Faqs faqs={clientConversionFAQs} />

      <Footer />

      <title>WhatsApp for Marketing Agencies | ChatMitra</title>
      <meta name="description" content="Grow client sales with WhatsApp marketing. Generate leads, automate support, and boost conversions with ChatMitra’s tools." />
      <meta name="keywords" content="WhatsApp for marketing agencies, lead generation, client sales WhatsApp, marketing automation, customer engagement" />
      <meta property="og:title" content="WhatsApp for Marketing Agencies | ChatMitra" />
      <meta property="og:description" content="Use WhatsApp to help clients win more leads, increase sales, and delight customers with personalized automation." />
      <meta property="og:url" content="https://blog.chatmitra.com/whatsapp-business-for-marketing-agency" />
      <meta property="og:type" content="website" />
    </>
  );
};

export default Marketing;